import React from 'react';
import TouchableElement from '@components/common/touchableElement';
import { View } from 'react-native';
import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { TableToolsItemProps } from './types';

const TableToolsItem = ({ onPress, iconUrl, iconHeigh, iconWidth, style }: TableToolsItemProps) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              justifyContent: 'center',
              alignItems: 'center',
              width: scale(27),
              height: scale(27),
            },
            style,
          ]}
        >
          <Svg icon={iconUrl} width={iconWidth} height={iconHeigh} />
        </View>
      )}
    </TouchableElement>
  );
};

export default TableToolsItem;
